import { breakpoints as auiBreakpoints } from '@soluto-private/mx-asurion-ui-react';

import { type BreakPoints } from './types';

export const breakpoints: BreakPoints<string> = {
  largeDesktop: auiBreakpoints.xxl,
  largeMobile: auiBreakpoints.sm,
  mediumDesktop: auiBreakpoints.xl,
  smallDesktop: auiBreakpoints.lg,
  smallLaptop: `@media (min-width: 1024px)`,
  smallMobile: `@media (min-width: 0px)`,
  tablet: auiBreakpoints.md,
};
